import { render, staticRenderFns } from "./StatsItem.vue?vue&type=template&id=3d4414f1&scoped=true&"
import script from "./StatsItem.vue?vue&type=script&lang=js&"
export * from "./StatsItem.vue?vue&type=script&lang=js&"
import style0 from "./StatsItem.vue?vue&type=style&index=0&id=3d4414f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4414f1",
  null
  
)

export default component.exports